import React from "react";

export const DisplayModeContext = React.createContext(
  {
    value: true,
    content: {},
    switchMode: () => {}
  }
);
